/* import __COLOCATED_TEMPLATE__ from './opamps-requirements.hbs'; */
import Component from '@glimmer/component';
import { numberToUserDisplay } from '@ebiz/pretty-num';
import SallenKeyLowPassIdealOpAmp from 'filter-wizard/models/implementation/sallen-key/low-pass/ideal-op-amp';

const voltageUnit = 'V';
const gbwUnit = 'Hz';

interface OpampsRequirementsArgs {
  limits: {
    allowedLimits: SallenKeyLowPassIdealOpAmp;
    recommendedLimits: SallenKeyLowPassIdealOpAmp;
    powerSpan: number;
    stageLetter: string;
  };
}

export default class OpampsRequirements extends Component<OpampsRequirementsArgs> {
  ////////////////////////////////////////////////////////////////////////////////
  // Properties                                                                 //
  ////////////////////////////////////////////////////////////////////////////////
  get stageLetter(): string {
    return this.args.limits.stageLetter;
  }
  get totalVoltageSupply(): string {
    return this.getAdjustedValue(this.args.limits.powerSpan, voltageUnit);
  }
  get requiredGBW(): string {
    return this.getAdjustedValue(this.args.limits.allowedLimits.gbw, gbwUnit);
  }
  get recommendedGBW(): string {
    return this.getAdjustedValue(this.args.limits.recommendedLimits.gbw, gbwUnit);
  }
  ////////////////////////////////////////////////////////////////////////////////
  // Functions                                                                  //
  ////////////////////////////////////////////////////////////////////////////////
  getAdjustedValue(rawValue: number | null, unit: string): string {
    let adjusted = '0';
    if (rawValue) {
      adjusted = numberToUserDisplay(rawValue, 'Engineering', 3, { showZeroes: false });
      adjusted = adjusted.indexOf('Inf') > -1 ? '0' : adjusted;
    }
    return adjusted + unit;
  }
}
